<ion-header>
  <ion-toolbar mode="md">
    <ion-title size="small">
      <ion-text *ngIf="!currentUser || !currentUser.only_dinein">
        {{ "popups.must-connect-to-network-modal.title" | translate }}
      </ion-text>
      <ion-text *ngIf="currentUser && currentUser.only_dinein">
        {{ "popups.dine-in-modal.continue-as-guest" | translate }}
      </ion-text>
    </ion-title>
    <ion-button
      (click)="closeModal()"
      size="small"
      slot="end"
      fill="clear"
      color="dark"
    >
      <ion-icon slot="icon-only" src="assets/ionicons/close.svg"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="ion-text-center ion-no-padding" style="max-width: 150px">
    <ng-lottie
      (animationCreated)="animationCreated($event)"
      [options]="options"
    ></ng-lottie>
  </ion-grid>
  <ion-grid>
    <ion-item lines="none">
      <ion-label class="ion-text-wrap ion-text-center" style="font-weight: 500"
        >{{
          "popups.must-connect-to-network-modal.connect-to-store-network"
            | translate
        }}
        <strong>
          "{{ storeWifiNetworkName ? storeWifiNetworkName : "" }}"</strong
        >
        {{ "popups.must-connect-to-network-modal.and-try-again" | translate }}
      </ion-label>
    </ion-item>

    <ion-item lines="none" *ngIf="storeWifiNetworkPassword">
      <ion-label class="ion-text-wrap ion-text-center" style="font-weight: 500"
        >{{
          "popups.must-connect-to-network-modal.storeWifiNetworkPassword"
            | translate
        }}:

        <ion-chip
          slot="end"
          color="primary"
          [disabled]="copyButtonDisabled"
          style="font-size: medium"
          (click)="copyAffiliateNumber(storeWifiNetworkPassword)"
        >
          <ion-icon
            *ngIf="!copyButtonDisabled"
            style="font-size: medium; margin-right: 5px"
            name="copy-outline"
          ></ion-icon>
          <div style="text-align: center; vertical-align: middle">
            <ion-label style="vertical-align: center" *ngIf="!failedToCopyText">
              <ion-text>
                {{
                  copyButtonDisabled
                    ? ("affiliate.copied" | translate) + "!"
                    : storeWifiNetworkPassword
                }}
              </ion-text>
            </ion-label>
            <ion-label *ngIf="failedToCopyText">Try again</ion-label>
          </div>
        </ion-chip>
      </ion-label>
    </ion-item>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-grid>
    <ion-row style="width: 100%">
      <ion-col class="ion-text-center">
        <ion-button (click)="closeModal()">{{
          "popups.must-connect-to-network-modal.ok" | translate
        }}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
